import { jsx as _jsx } from "react/jsx-runtime";
import { Modal, Table } from "antd";
import { formatDisplayDate } from "../../utils/commonUtil";
const SubProjectRiskStatusInfoModal = ({ isModalOpen, handleOk, handleCancel, modalContent, title }) => {
    const columns = [
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
        },
        {
            title: 'Reason',
            dataIndex: 'reason',
            key: 'reason',
        },
    ];
    const dataSource = modalContent === null || modalContent === void 0 ? void 0 : modalContent.map((data, index) => {
        return {
            key: index,
            date: formatDisplayDate(data === null || data === void 0 ? void 0 : data.dtCreateDate),
            reason: data === null || data === void 0 ? void 0 : data.strComments,
        };
    });
    return (_jsx(Modal, { title: title, open: isModalOpen, onOk: handleOk, onCancel: handleCancel, children: _jsx(Table, { columns: columns, dataSource: dataSource }) }));
};
export default SubProjectRiskStatusInfoModal;
